<div class="full-content">
  <div class="chat-header">
    <div class="sparkles-container">
      <div class="sparkles-frame"></div>
      <f-icon
        icon-config='{"iconName": "sparkles", "iconType": "solid"}'
      ></f-icon>
    </div>
    <div class="header-title">AI Assistant</div>
    <div class="beta-label">Beta</div>
    <div class="header-actions">
      <button class="action-icon" (click)="clearChatHistory()" title="Clear chat history">
        <f-icon icon-config='{"iconName": "trash", "iconType": "light"}'></f-icon>
      </button>
      <button class="close-icon" (click)="onClose()">
        <f-icon icon-config='{"iconName": "xmark", "iconType": "solid"}'></f-icon>
      </button>
    </div>
  </div>
  <div class="content-area" #chatContainer>
    <div
      *ngIf="promptDialog && (promptDialog?.length || 0) > 0"
      class="scroll-area"
    >      <div
        *ngFor="let dialog of promptDialog; let i = index;"
        class="dialog-container"
        #item
      >        <app-dialog
          [dialog]="dialog"
          [errorWithWebSocket]="errorWithWebSocket"
          [errorResponseReceived]="errorResponseReceived"
          [hasExcessiveDelay]="hasExcessiveDelay"
          [isLoading]="
            isLoading &&
            dialog.type === 'prompt' &&
            i + 2 === promptDialog.length
          "
          [isLast]="isLastResponse(i)"
          [isLastItem]="isLastItem(i)"
          (clickEvent)="onClickEvent($event)"
          (embeddedLinkClick)="onEmbeddedLinkClick($event)"
        ></app-dialog>
      </div>
      <div
        *ngIf="
          ((connectionStatus !== ConnectionStatus.CONNECTED &&
          connectionStatus !== ConnectionStatus.CONNECTING) && 
          !isReconnecting) || errorResponseReceived
        "
        class="connection-status-message"
      >
        <f-alert variant="error">
            <p>{{ errorMessage || 'Your login session has expired. Please log in again.' }}</p>
        </f-alert>
      </div>
    </div>
  </div>
  <form class="user-input__container" [formGroup]="promptForm">
    <f-text-input
      class="user-input__form-control"
      uuid="prompt"
      [value]="formValue || ''"
      type="text"
      (inputChanged)="onTextareaChanged($event)"
      name="prompt"
      [placeholder]="'Ask me about reports...'"
      [disabled]="isProcessingMessage || connectionStatus !== ConnectionStatus.CONNECTED"
    >
    </f-text-input>
    <div>
      <div class="user-input__send-btn">
        <f-button
          icon-config='{"iconName": "paper-plane", "iconType": "solid", "iconPlacement": "right"}'
          class="input-submit-btn"
          type="submit"
          text="Send"
          variant="progressive"
          [disabled]="
            isSendButtonDisabled ||
            connectionStatus !== ConnectionStatus.CONNECTED ||
            isProcessingMessage
          "
          (buttonClicked)="onButtonClicked($event)"
        >
        </f-button>
      </div>
    </div>
  </form>
</div>
